import React from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import withApollo from '../lib/apollo';
import withQuery from '../lib/withQuery';
import MarketList from '../components/Markets';
import MarketPlaceHeading from '../components/Markets/Heading';
import marketsConnectionQuery
from '../lib/queries/products/marketsConnectionQuery.graphql';
import getBreadcrumbs from '../components/Markets/getBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';
import { marketplaceLogoImageConfigurations } from '../lib/imageConfigurations';

const MarketListWithQuery = withQuery(MarketList);
const LIMIT = 50;

const MarketsPage = () => (
  <MarketPlaceHeading
    breadcrumbs={getBreadcrumbs()}
  >
    <MarketListWithQuery
      query={marketsConnectionQuery}
      variables={{
        first: LIMIT,
        imageConfigurations: marketplaceLogoImageConfigurations,
      }}
      errorMessage="Error loading markets."
    />
  </MarketPlaceHeading>
);

MarketsPage.getLayout = (page) => (
  <Layout header={<Hero />}>
    {page}
  </Layout>
);

MarketsPage.getInitialProps = redirectRouteToDomain(
  'markets',
);

export default withApollo(MarketsPage);
